module.exports = __webpack_public_path__ + "static/media/editIcon.3bbd4569.svg";